import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

const swiperContentEl = document.querySelector(
  '.module-testimonials__testimonials'
)

new Swiper(swiperContentEl, {
  spaceBetween: 24,
  breakpoints: {
    992: {
      spaceBetween: 32
    }
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.module-testimonials__slider-button--next',
    prevEl: '.module-testimonials__slider-button--prev'
  },
  pagination: {
    el: '.module-testimonials__slider-indicators',
    clickable: true,
    bulletClass: 'module-testimonials__slider-indicator',
    bulletActiveClass: 'module-testimonials__slider-indicator--active',
    renderBullet: function (index, className) {
      return `<button class="${className}" data-slide="${index}"></button>`
    }
  },
  modules: [Navigation, Pagination]
})
